import styles from './Benefits.module.css';

function Benefits(){
    return (
        <section id="beneficios" className={`${styles.benefits}`}>
            <div className="row d-flex px-sm-5 px-3 mb-5 pb-5">      
                <div className="col-lg-7 text-start ms-lg-5 mb-4">
                    <h2 className="display-sm-5 fw-bold mb-4">Como o Focus pode te ajudar a ter mais foco?</h2>
                    <p>Por meio dos registros diários (que contém os horários de início, término e duração de uma atividade em cada dia do mês) você obtém respostas para questões como:</p>
                    <ul>
                        <li>Será que estou dedicando tempo o suficiente a esta atividade?</li>
                        <li>Será que iniciar essa atividade neste horário está sendo compensatório?</li>
                        <li>Será que esta atividade está tomando tempo demais no meu dia a dia e impactando nos meus demais afazeres?</li>
                        <li>Minha gestão do tempo é realmente eficaz?</li>
                    </ul>
                </div>
                <img className={`${styles.activities_icons_image} col-lg-3 mx-auto`} src="/img/activities_icons.webp" alt="Ícones para atividades"/>
            </div>
            <div className="row d-flex px-4 mt-5 pt-5">
                <img className={`${styles.user_image} col-xl-3 mx-auto`} src="/img/user.webp" alt=""/>
                <div className="col-xl-7 mb-4 text-start mt-xl-0 mt-4">
                    <h2 className="display-sm-5 fw-bold mb-4 text-xl-start text-center">Para quem é voltado o Focus?</h2>
                    <p>O Focus é o aliado ideal se você:</p>
                    <ul>
                        <li>Trabalha o dia todo, porém estuda no tempo livre para conseguir algo melhor.</li>
                        <li>Trabalha em regime CLT, porém cuida de um negócio digital quando está em casa.</li>
                        <li>Trabalha em regime CLT e quer manter um registro próprio das horas trabalhadas para futuras utilidades (como pedir uma folga em caso de muitas horas extras).</li>
                        <li>Pratica exercícios físicos em busca de um corpo definido.</li>
                    </ul>
                    <p className="fw-bold text-primary pt-2">Resumindo: <span className="text-dark">é a solução para quem busca uma gestão eficaz do tempo, um registro diário de como suas horas estão sendo usadas e mais foco em seus objetivos.</span></p>
                </div>
            </div>
        </section>
    )
}

export default Benefits;